import { Button, Modal, Text } from "@marketplace/ui";
import { useAtomValue } from "jotai";
import { useResetAtom } from "jotai/utils";
import { useTranslation } from "react-i18next";

import { resendVerificationModalAtom } from "../../atoms";
import { useResendVerificationMutation } from "../../hooks/mutations/use-resend-verification-mutation";

export const ResendVerificationModal = () => {
  const { t } = useTranslation("users");
  const { visible, data } = useAtomValue(resendVerificationModalAtom);
  const resetResendVerificationModal = useResetAtom(
    resendVerificationModalAtom
  );
  const { mutate: resendVerification, isPending } =
    useResendVerificationMutation();

  const handleResend = () => {
    if (data?.id && data?.email) {
      resendVerification(
        { user_id: data.id, email: data.email },
        {
          onSuccess: () => {
            resetResendVerificationModal();
          }
        }
      );
    }
  };

  return (
    <Modal
      opened={visible}
      onClose={resetResendVerificationModal}
      title={
        <Text type="heading">
          {t("sellerListPage.resendVerificationModal.title")}
        </Text>
      }
      size={366}
      withCloseButton={false}
      classNames={{
        header: "!pt-6 !pb-0 !min-h-fit",
        body: "!p-6"
      }}
    >
      <Text type="paragraph" className="text-center mb-6">
        {t("sellerListPage.resendVerificationModal.description")}
      </Text>

      <div className="flex gap-x-[14px]">
        <Button
          fullWidth
          variant="secondary"
          onClick={resetResendVerificationModal}
        >
          {t("sellerListPage.resendVerificationModal.button.cancel")}
        </Button>
        <Button
          fullWidth
          variant="primary"
          onClick={handleResend}
          loading={isPending}
        >
          {t("sellerListPage.resendVerificationModal.button.resend")}
        </Button>
      </div>
    </Modal>
  );
};
